import { LogsService } from "@gtpl/shared-services/user-logs";
import { Injectable } from "@nestjs/common";
import { CostSheetRepo } from "./repository/costing-repo";
import { ConfirmedContainersReq, ContainersReq, CostSheetModel, CostingSheetResponse,EnquiryAssessmentResponseModel, EnquiryAssessmentUpdateReq, EnquiryIdreq, EnquiryLifecycleStatusEnum, QuoteRequest, getAllEnquiryInfoReq,productRates,StyleWeighmentEnum } from "@gtpl/shared-models/enquiry-management";
import { CommonResponse, FgPriceListCategoryEnum, GlobalPriceType, TypeEnum } from "@gtpl/shared-models/masters";
import { CommandOptions, Repository, TransactionManager, getManager } from "typeorm";
import appSettings from "apps/services/config";
import { CostSheetEntity } from "./entity/cost-sheet-entity";
import { EnquiryLogEntity } from "../enquiries/entites/enquiry-log";
import { EnquiriesEntity } from "../enquiries/entites/enquiries";
import { InjectRepository } from "@nestjs/typeorm";
import { EnquiryProdctsEntity } from "../enquiries/entites/enquiry-products";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { MFGCostsEntity } from "./entity/mfg-costs-entity";
import { FreightForwardExpensesEntity } from "./entity/freight-forward-expenses-entity";
import { EnquiriesRepository } from "../enquiries/repositories/enquiries.repo";
import { EnquiriesProductsRepository } from "../enquiries/repositories/enquiry-products-repo";
import { CategoryEnum, GlobalVariableValues, HarvestTypes, PackingCategoryEnum } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from '@gtpl/shared-models/raw-material-procurement';
import { UnitsOfWeightInput } from "@gtpl/shared-models/sale-management";

@Injectable()
export class CostingService {
    constructor(
        @InjectRepository(EnquiryLogEntity)
        private enquiryLogRepo: Repository<EnquiryLogEntity> ,
                private readonly  costSheetRepo: CostSheetRepo ,
                private enquiryRepo:EnquiriesRepository,
                private enquiryProductsRepo:EnquiriesProductsRepository,
        private logService:LogsService,
        @InjectRepository(EnquiriesEntity)
        private enquiriesRepo: Repository<EnquiriesEntity>

    ) {}
    async getQuotationSentEnquiries(req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.enquiry_id AS enquiryId,e.enquiry_number AS enquiryNumber,
            e.country_id AS countryId,c.country_name AS countryName,
            e.destination_id AS destinationId,d.destination_name AS destination,
            e.unit_id,u.unit_name AS unitName,
            e.source_from as sourceFrom,
            e.agent_id,CONCAT(cus.client_code,'-',cus.client_name)AS agent,
            e.buyer_id,CONCAT(ec.end_customer_code,'-',ec.end_customer_name) AS buyer,
            e.etd,DATEDIFF(NOW(), e.updated_at) AS aging,e.enquiry_date as enquiryDate
            FROM enquiries e
            LEFT JOIN `+appSettings.masters_db+`.countries c ON e.country_id = c.country_id
            LEFT JOIN `+appSettings.masters_db+`.destination d ON d.destination_id = e.destination_id
            LEFT JOIN `+appSettings.masters_db+`.unitcodes u ON u.unit_code_id = e.unit_id
            LEFT JOIN `+appSettings.masters_db+`.customers cus ON cus.cust_id = e.agent_id
            LEFT JOIN `+appSettings.masters_db+`.end_customers ec ON ec.end_customer_id = e.buyer_id WHERE 1=1`
            if(req.tabName != undefined){
                if(req.tabName == 'QUOTATION SENT'){
                    query = query + ` and e.life_cycle_status = "QUOTATION SENT"`
                }
                if(req.tabName == 'ACCEPTANCE PENDING'){
                    query = query + ` and e.life_cycle_status = "ACCEPTANCE PENDING"`
                }
            }
            if(req.enquiryNo != undefined){
                query=query+` and e.enquiry_number= '${req.enquiryNo}'`
            }
            
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getEnquiryNo (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT enquiry_id AS enquiryId, enquiry_number AS enquiryNo FROM enquiries WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and life_cycle_status ='${req.tabName}'`
            }
            query = query + ` GROUP BY enquiry_id ORDER BY enquiry_number`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async confirmEnquiry(req:EnquiryAssessmentUpdateReq):Promise<CommonResponse>{
        return null
    }

    async getExchangeRate(enquiryId:number,currencyId:number){
        const manager = getManager()
        const exchangeRatesQry = `SELECT exchange_rate as exchangeRate FROM ${appSettings.masters_db}.exchange_rates WHERE currency_id = ${currencyId} AND effective_from < DATE(NOW()) ORDER BY effective_from DESC LIMIT 1`
        return await manager.query(exchangeRatesQry)
    }

    async getOcenFrightOfEnquiry(countryId:number,destinationId:number){
        const manager = getManager()
        const oceanFrieghtRateQry = `SELECT avg(total) as oceanFreightRateUSD FROM ${appSettings.masters_db}.ocaen_freight_rates WHERE country_id = ${countryId} AND destination_id = ${destinationId}`
        return await manager.query(oceanFrieghtRateQry)

    }

    async generateCostSheet(req:EnquiryIdreq):Promise<CostingSheetResponse>{
        //get basic details of an enqiry
        const manager=getManager()
        const transmanager = new GenericTransactionManager();
        await transmanager.startTransaction()
        if(req.operation == 'regenerate'){
            console.log('regenerate')
            const deletePreviousRecord = await transmanager.getRepository(CostSheetEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
            console.log(deletePreviousRecord)
            if(deletePreviousRecord.affected){
                const deleteFrieghtForwardExp = await transmanager.getRepository(FreightForwardExpensesEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
                if(deleteFrieghtForwardExp.affected){
                const deleteMfgCosts = await transmanager.getRepository(MFGCostsEntity).delete({enquiryEntity:{enquiryId:req.enquiryid}})
                if(deleteMfgCosts.affected){
                    console.log('ok')
                    const updateStatus = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryid},{lifeCycleStatus:EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED,isRegenearted:true})
                    if(!updateStatus.affected){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Something went wrong in updating status in enquiries')
                    }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in MFG costs')
                }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in Freight and Forward Expenses')
                }
                }else{
                    await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'Something went wrong in deleting previous record in cost sheet')
                }
        }
        //need to check if cost sheet generated or not for the selected Enquiry
        const checkCostSheet = await transmanager.getCustomRepository(CostSheetRepo).count({where:{enquiryEntity:{enquiryId:req.enquiryid}}})
        console.log(checkCostSheet,'checkcostsheet')
        if(!(checkCostSheet > 0)){
            const enquiryInfo = await this.enquiryRepo.getEnquiryDetailsForCostSheet(req.enquiryid)
            if(enquiryInfo.length > 0){
                const datesInfo = await this.enquiryRepo.getEnquiryStatusInfo(req.enquiryid)
                //datesInfo.assesmentApprovalDate
                const exchangeRate = await this.getExchangeRate(req.enquiryid,enquiryInfo[0].currencyId)
                //exchangeRate[0]
                if(exchangeRate.length > 0){
                    //get ocean fright rate in USD against country and destination from ocean freight rates data
                    const oceanFrieghtRate = await this.getOcenFrightOfEnquiry(enquiryInfo[0].countryId,enquiryInfo[0].destinationId) 
                    if((oceanFrieghtRate[0].oceanFreightRateUSD == null)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'No Ocean freight rate found for selected enquiry')
                    }
                    //product against cost sheet rates
                    //1.yield
                    const enquiryProducts = await this.enquiryProductsRepo.getEnquiryProductsForEnquiry(req.enquiryid)
                    //container wise products list map
                    const containerProductsMap = new Map<number,number>()
                    let groupQty = 0
                    for(const productitem of enquiryProducts){
                        if(UnitsOfWeightInput.find(item => item.value == productitem.uomId).name == 'lb'){
                            groupQty = (productitem.shrimpQty)*0.454
                        }else{
                            groupQty = productitem.shrimpQty
                        }
                        if(containerProductsMap.has(productitem.group)){
                            const prevQty = containerProductsMap.get(productitem.group)
                            containerProductsMap.set(productitem.group,(Number(prevQty)+Number(groupQty)))
                        }else{
                            containerProductsMap.set(productitem.group,groupQty)
                        }
                    }
    
                    //yield percentages data with map
                    const variantIdsQry = `select group_concat(distinct(variant_id)) as variantId from ${appSettings.enquiry_db}.enquiry_products where enquiry_id = ${req.enquiryid} `
                    const variantData = await manager.query(variantIdsQry)
                    const yieldPerQry = `SELECT sku_code_id as variantId,loss_or_gain_percentage as yieldper,food_type_id as foodTypeId,value_addition_one_id as valoneId,value_addition_two_id as valtwoId,grades.grade_min_count as minGrade,grade_max_count as maxGrade FROM ${appSettings.masters_db}.sku_codes 
                    left join ${appSettings.masters_db}.grades on grades.grade_id = sku_codes.grade_id
                    WHERE sku_code_id in (${variantData[0].variantId})`
                    const yieldData = await manager.query(yieldPerQry)
                    if(!(yieldData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'yield percentage not found')
                    }
                    const yieldPerMap = new Map<number,number>()
                    //peeling rates
                    let foodTypes = []
                    let valAddOnes = []
                    let valAddTwos = []
                    let minGrades = []
                    let maxGrades = []
                    interface peelingModel{
                        foodTypeId:number,
                        valaddOneId:number,
                        valaddTwoId:number,
                        minGrade:number,
                        maxGrade:number,
                    }
                    yieldData.forEach(rec => {
                        if(!yieldPerMap.has(rec.variantId)){
                            yieldPerMap.set(rec.variantId,rec.yieldper)
                        }
                        if(!(valAddOnes.includes(rec.valoneId))){
                            valAddOnes.push(rec.valoneId)
                        }
                        if(!(valAddTwos.includes(rec.valtwoId))){
                            valAddTwos.push(rec.valtwoId)
                        }
                        if(!(minGrades.includes(rec.minGrade))){
                            minGrades.push(rec.minGrade)
                        }
                        if(!(maxGrades.includes(rec.maxGrade))){
                            maxGrades.push(rec.maxGrade)
                        }
                        if(!(foodTypes.includes(rec.foodType))){
                            foodTypes.push(rec.foodTypeId)
                        }
                        
                    });

                    //packCount 
                    
                    
                    // yieldData.forEach(rec => {
                    //     console.log(Number(rec.yieldper),'----per')
                    //     if(Number(rec.yieldper) <= 0){
                    //         console.log('7777')
                    //         break
                    //         // return new CostingSheetResponse(false,0,'Yield percentage should not be zero for all products')
                    //     }else{
                    //         if(!yieldPerMap.has(rec.variantId)){
                    //             yieldPerMap.set(rec.variantId,rec.yieldper)
                    //         }
                    //     }
                    // });
                    for(const rec of yieldData){
                        if(Number(rec.yieldper) <= 0){
                            await transmanager.releaseTransaction()
                            return new CostingSheetResponse(false,0,'Yield percentage should not be zero for all products')
                        }else{
                            if(!yieldPerMap.has(rec.variantId)){
                                yieldPerMap.set(rec.variantId,rec.yieldper)
                            }
                        } 
                    }
                    //pack count
                    //dependency need to add in grades master and enquiry form
                    //rmRate should get from from rate chart against the rm count of the product
                    const rmratesMap = new Map<number,number>()
                    const rmratesQry = `SELECT COUNT as count,price FROM ${appSettings.rm_procure_db}.rm_rates where category = '${CompanyCategoryEnum.OWN}' and type = '${HarvestTypes.Re_Weighment}'`
                    const rmratesData = await manager.query(rmratesQry)
                    if(!(rmratesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'RM rates not found')
                    }
                    rmratesData.forEach(element => {
                        if(!(rmratesMap.has(element.count))){
                            rmratesMap.set(element.count,element.price)
                        }
                    });
                    //manufacturing cost is the sum of fixed component rates and peeling rate
                    //fixed component rates
                    // const mfgRatesQry = `SELECT SUM(price) as mfgComponentsCost FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG'`;
                    // const mfgRatesQry = `SELECT SUM(price) AS mfgComponentsCost , SUM(CASE WHEN component = 'Boiler Fuel Cost' THEN 0 ELSE price END) AS mfgCostWithoutBoilerFuel FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG'
                    // `;
                    // const mfgRatesData = await manager.query(mfgRatesQry)
                    //if pack category wise prices having then it should be added to mfg cost
                    const mfgRatesQry = `SELECT sum(price)AS mfgwithBoilerCost,packing_category as packCategory,SUM(CASE WHEN component = 'Boiler Fuel Cost' THEN 0 ELSE price END) AS mfgCostWithoutBoilerFuel FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'MFG' group by packing_category`;
                    const mfgRatesData = await manager.query(mfgRatesQry)
                    if(!(mfgRatesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'MFG component rates not found')
                    }
                    let mfgRatesMap = new Map<string, {withBoilerCost:number,withoutBoilerCost:number}>()
                    for(const rec of mfgRatesData){
                        if(!(mfgRatesMap.has(rec.packCategory))){
                            mfgRatesMap.set(rec.packCategory,{withBoilerCost:rec.mfgwithBoilerCost,withoutBoilerCost:rec.mfgCostWithoutBoilerFuel})
                        }
                    }
                    //mfgRatesData[0].mfgComponentsCost
                    //peeling Rates
                    let peelingrateMap = new Map<string,string>()
                    const pellingInfoQry = `SELECT min_grade as minGrade,max_grade as maxGrade,rate_per_kg as price,food_type_id as foodTypeId,value_add_1 as valoneId,value_add_2 as valtwoId  FROM ${appSettings.masters_db}.deheading_peeling_chart WHERE min_grade IN(${minGrades}) AND max_grade IN(${maxGrades}) AND food_type_id IN(${foodTypes}) AND value_add_1 IN(${valAddOnes}) AND 
                    value_add_2 IN(${valAddTwos})`
                    const peelingRatesInfo = await manager.query(pellingInfoQry)
                    if(!(peelingRatesInfo.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'No Peeling Rates found')
                    }
                    for(const peelingRatesRec of peelingRatesInfo){
                        const peelingPriceObj = {foodTypeId:peelingRatesRec.foodTypeId,
                            valaddOneId:peelingRatesRec.valoneId,
                            valaddTwoId:peelingRatesRec.valtwoId,
                            minGrade:peelingRatesRec.minGrade,
                            maxGrade:peelingRatesRec.maxGrade}
                            const mapKey = JSON.stringify(peelingPriceObj)
                        if(!peelingrateMap.has(mapKey)){
                                peelingrateMap.set(mapKey,peelingRatesRec.price)
                            }
                    }
                    //pack material cost should fetch against product and pack style  from packing material price chart
                    // let packmaterialMap = new Map<number,Map<number,number>>() //product,packstyle,price
                    // const packMaterialQuery = `select product_id as productId,pack_style_id as packStyleId,price from ${appSettings.masters_db}.packing_material_prices where product_id in(${variantData[0].variantId})`
                    // const packMaterialnfo = await manager.query(packMaterialQuery)
                    // if(!(packMaterialnfo.length > 0)){
                    //     return new CostingSheetResponse(false,0,'Pack Material price rates not found')
                    // }
                    // for(const packMateriaRec of packMaterialnfo){
                    //     if(!(packmaterialMap.has(packMateriaRec.productId))){
                    //         packmaterialMap.set(packMateriaRec.productId,new Map<number,number>())
                    //         if(!(packmaterialMap.get(packMateriaRec.productId).has(packMateriaRec.packStyleId))){
                    //             packmaterialMap.get(packMateriaRec.productId).set(packMateriaRec.packStyleId,packMateriaRec.price)
                    //         }
                    //     }else{ 
                    //         if(!(packmaterialMap.get(packMateriaRec.productId).has(packMateriaRec.packStyleId))){
                    //             packmaterialMap.get(packMateriaRec.productId).set(packMateriaRec.packStyleId,packMateriaRec.price)
                    //         }
                    //     }
                    // }
                    // return new CostingSheetResponse(false,0,'found')

                    
                    //Freight and Farward Expenses are the sum of ocean freigh charge for destination and fixed forwarding prices
                    const oceanFreightInUsd = oceanFrieghtRate[0].oceanFreightRateUSD
                    //global forwarding prices
                    const globalPricesQry = `SELECT component,price,type FROM ${appSettings.masters_db}.global_price_chart`
                    const globalPricesData = await manager.query(globalPricesQry)
                    if(!(globalPricesData.length > 0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Global price rates not found')
                    }
                    // let totalGlobalPrice = 0
                    // globalPricesData.forEach(priceRec => {
                    //     if(priceRec.component == 'Antidumping duty'){
                    //         totalGlobalPrice += priceRec.price
                    //     }
                    // });
                    //fixed cost claculation will be the sum of all fixed component prices
                    const fixedRates = `SELECT SUM(price) as fixedCost FROM ${appSettings.masters_db}.fixed_prices_chart WHERE category = 'Fixed'`;
                    const fixedRatesData = await manager.query(fixedRates)
                    if(!(fixedRatesData.length >0)){
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Fixed cost component rates not found')
                    }
                    //quoteSent Enquiries..If quotation sent then quote price should be fetch
                    interface QuoteInfo {
                        quotePrice:number,
                        addedPriceToRmrate:number,
                        reducedPriceToRmRate:number,
                        costOfSalesForAddedRmRate:number,
                        costOfSalesForReducedRmRate:number,
                        quoteStatus:number,
                        incentives:number
                    }
                    // const qouteDetailsMap = new Map<number,QuoteInfo>()
                    // let quoteSentFlag:boolean = false
                    // let quoteconcatString = 'quote_status = 1'
                    
                    // const quoteSentEnquiriesQry = commonQry+`${quoteconcatString}`
                    // const quoteSentEnquiriesData = await manager.query(quoteSentEnquiriesQry)
                    // if((quoteSentEnquiriesData.length > 0)){
                    //     console.log(quoteSentEnquiriesData,'quoteSentEnquiriesData')
                    //     quoteSentFlag = true
                    //     quoteSentEnquiriesData.forEach(rec => {
                    //         if(!(qouteDetailsMap.has(rec.variantId))){
                    //             qouteDetailsMap.set(rec.variantId,{
                    //                 quotePrice:rec.quotePrice,
                    //                 addedPriceToRmrate:rec.addedPriceToRmrate,
                    //                 reducedPriceToRmRate:rec.reducedPriceToRmRate,
                    //                 costOfSalesForAddedRmRate:rec.costOfSalesForAddedRmRate,
                    //                 costOfSalesForReducedRmRate:rec.costOfSalesForReducedRmRate,
                    //                 quoteStatus:rec.quoteStatus,incentives:rec.incentives})
                    //         }
    
                    //     })
                    //     console.log(qouteDetailsMap)
                    // }
                    //If buyer offer price captired after quotation sent then need to fetch the details from below query
                    interface OfferPriceInfo {
                        netPLOnBuyerPrice:number,
                        totalProfitLoss:number,
                        buyerOfferPrice:number,
                        plPercentage:number,
                        contributionPercentage:number,
                    }
                    const buyerPriceDataMap = new Map<number,OfferPriceInfo>()
                    let buyerOfferPriceFlag:boolean = false
                    // let buyerPriceconcatString = 'and buyer_offer_price > 0'
                    // const buyerOfferPriceInfoQry = commonQry+`${buyerPriceconcatString}`
                    const buyerOfferPriceData = await transmanager.getCustomRepository(CostSheetRepo).getBuyerOfferPriceOfEnquiry(req.enquiryid,variantData[0].variantId,transmanager)
                    if(buyerOfferPriceData.length > 0){
                        buyerOfferPriceFlag = true
                        buyerOfferPriceData.forEach(priceItem => {
                            if(!(buyerPriceDataMap.has(priceItem.variantId))){
                                buyerPriceDataMap.set(priceItem.variantId,{
                                    netPLOnBuyerPrice:priceItem.netpl,
                                    totalProfitLoss:priceItem.totalPl,
                                    buyerOfferPrice:priceItem.buyerOfferPrice,
                                    plPercentage:priceItem.plPercentage,
                                    contributionPercentage:priceItem.contributionPercentage
                                })
                            }
                        });
                    }
                    //prevailing FG market rate
                    let ProductPriceInfoMap = new Map<number,number>()
                    const fgProductPriceQry = `SELECT product_id AS variantId,min_price as price FROM ${appSettings.masters_db}.product_price_list WHERE product_id IN(${variantData[0].variantId}) and category = '${FgPriceListCategoryEnum.EXPORT}'`
                    const fgProductPriceData = await manager.query(fgProductPriceQry)
                    // if(fgProductPriceData.length != (variantData[0].variantId.split(',')).length){
                    //     await transmanager.releaseTransaction()
                    //     return new CostingSheetResponse(false,0,'No Market Rates found for product')
                    // }
                    fgProductPriceData.forEach(productPriceRec=>{
                        if(!(ProductPriceInfoMap.has(productPriceRec.variantId))){
                            ProductPriceInfoMap.set(productPriceRec.variantId,productPriceRec.price)
                        }
                    })
                    //previous confirmed price
                    let prevEnquiryDataMap = new Map<number,number>()//variantid,price
                    let sameBuyerEnquiriesMap = new Map<number,number>()//variantid,price
                    let prevenquiriesFlag:boolean = false
                    let sameBuyerEnquiryFlag:boolean = false

                    //check the previous confirmed enquiries with same buyer
                    const prevConfirmedEnquiriesData = await this.enquiryRepo.getPrevConfirmedEnquiries(variantData[0].variantId)
                    const sameBuyerPrevEnquiryData = await this.enquiryRepo.getSameBuyerConfirmedEnquiries(variantData[0].variantId,enquiryInfo[0].buyerId)
                    if(sameBuyerPrevEnquiryData.length > 0){
                        sameBuyerEnquiryFlag = true
                        sameBuyerPrevEnquiryData.forEach(record => {
                            if((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/0.454
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 1 || record.uomId == 4)){
                                record.unitPrice = record.unitPrice/record.caseWeight
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/(0.454*record.caseWeight)
                            }
                            if(!sameBuyerEnquiriesMap.has(record.prodct)){
                                sameBuyerEnquiriesMap.set(record.variantId,record.unitPrice)
                            }
                        });
                    }
                    let unitPricemap = new Map<number,number>()//variantid,price
                    if(prevConfirmedEnquiriesData.length > 0){
                        prevenquiriesFlag = true
                        //assign avarage of all prices for one variant
                        let avgPrice = 0
                        let unitPrice = 0
                        let prevUnitPrice = 0
                        let totalProducts = 0
                        prevConfirmedEnquiriesData.forEach((record,index) => { 
                            if((record.category == PackingCategoryEnum.POUCH || record.category == PackingCategoryEnum.SKEWER) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/0.454
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 1 || record.uomId == 4)){
                                record.unitPrice = record.unitPrice/record.caseWeight
                            }
                            if((record.category == PackingCategoryEnum.PLATTER || record.category == PackingCategoryEnum.RING) && (record.uomId == 2 || record.uomId == 3)){
                                record.unitPrice = record.unitPrice/(0.454*record.caseWeight)
                            }
                            if(!(prevEnquiryDataMap.has(record.variantId))){    
                                prevEnquiryDataMap.set(record.variantId,record.unitPrice)
                                unitPricemap.set(record.variantId,record.unitPrice)  
                            }else{
                                unitPrice = Number(unitPricemap.get(record.variantId))+Number(record.unitPrice)
                                unitPricemap.set(record.variantId,unitPrice)
                                prevUnitPrice = unitPricemap.get(record.variantId)
                                totalProducts += 1
                                avgPrice = prevUnitPrice/(totalProducts+1)
                                prevEnquiryDataMap.set(record.variantId,avgPrice)
                            }
                        });
                    }
                    let ocaenFreightPerKg
                    let productPricesData = []
                    let adPer = 0
                    let cvdPer = 0
                    for(const product of enquiryProducts){
                        //shrimp qty based on container,if multiple products having in same container then quantity based calculations should be done for sum of tow products qty
                        // if(UnitsOfWeightInput.find(item => item.value == product.uomId).name == 'lb'){
                            product.shrimpQty = containerProductsMap.get(product.group)
                        // }
                        //yield
                        const yieldVal = yieldPerMap.get(product.variantId)
                        //frozen Yield
                        //if style weighment is FWFC or NWFC rmcount should caculate on frozen yield
                        const frozenyield = Number(yieldVal)+Number(yieldVal*(product.glaze/100))
                        const packCount = product.packCount
                        //RM count calculation
                        let rmCount
                        //rmcount for frozen counts and net counts 
                        if(product.styleWeighment == StyleWeighmentEnum.FWFC || product.styleWeighment == StyleWeighmentEnum.NWFC){
                            rmCount = Math.round(1000/((454/packCount/frozenyield)*100))
                        }else{
                            rmCount = Math.round(1000/((454/packCount/yieldVal)*100))
                        }
                        console.log(rmCount,'countval')
                        // console.log(rmCount,'rmCountkkk')
                        //prevailing rmrate
                        const rmRate = rmratesMap.get(rmCount) ? rmratesMap.get(rmCount) : 0
                        if(rmratesMap.get(rmCount) == undefined){
                            await transmanager.releaseTransaction()
                            return new CommonResponse(false,0,'Rm rate not found for the count')
                        }
                        //rm cost calculation
                        const rmCost = Math.round(rmRate/(yieldVal/100))
                        //mfgcost = mfgcomponents cost+peeling cost per kg
                        const key = {
                            foodTypeId: product.foodTypeId,
                            valaddOneId: product.valoneId,
                            valaddTwoId: product.valtwoId,
                            minGrade: Number(product.minGrade),
                            maxGrade: Number(product.maxGrade)
                        };

                        const peelingCost = peelingrateMap.get(JSON.stringify(key))
                        if(peelingCost == undefined){
                            await transmanager.releaseTransaction()
                            return new CommonResponse(false,0,'Peeling cost is not defined for product')
                        }
                        console.log(mfgRatesMap)
                        console.log(product.category)
                        if(mfgRatesMap.get(product.category) == undefined){
                            mfgRatesMap.set(product.category,{withBoilerCost:0,withoutBoilerCost:0})
                        }
                        let mfgComponentCost = product.foodTypeId == GlobalVariableValues.cookingId ? Number((mfgRatesMap.get('ALL').withBoilerCost)+(mfgRatesMap.get(product.category).withBoilerCost)) : Number((mfgRatesMap.get('ALL').withoutBoilerCost)+(mfgRatesMap.get(product.category).withoutBoilerCost))
                        const mfgCost = Math.round(Number(mfgComponentCost)+Number(peelingCost))
                        //salecommissiion directly capturing from enquiry(percentage)
                        const saleCommPer = enquiryInfo[0].saleCommissionPercentage
                        const saleCommission = Math.round(((product.shrimpQty/0.454)*(saleCommPer/100)*(exchangeRate[0].exchangeRate))/product.shrimpQty)
                        //pack material cost
                        // const packmaterailCost = packmaterialMap.get(product.variantId).get(product.packStyleId)
                        const packmaterailCost = product.packMaterialCost
                        // const packmaterailCost = 14 //uncomm
                        //Freight and Farward Expenses are the sum of ocean freigh charge for destination and fixed forwarding prices
                        ocaenFreightPerKg = (oceanFreightInUsd*(Number(exchangeRate[0].exchangeRate)+4))/product.shrimpQty
                        let totalGlobalPrice = 0
                        let percentageSum = 0
                        
                        let percentageVal = 0

                        globalPricesData.forEach(priceRec => {
                            if(priceRec.type == GlobalPriceType.Value){
                                totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                                // totalGlobalPrice += Number(priceRec.price)
                            }
                            // if(enquiryInfo[0].country == 'USA' && priceRec.component == 'Agricultural Marketing Cess'){
                            //     totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                            // }
                            if(priceRec.component == 'Antidumping duty'){
                                adPer = priceRec.price
                            }
                            if(priceRec.component == 'CVD'){
                                cvdPer = priceRec.price
                            }
                            if(priceRec.type == GlobalPriceType.Percentage){
                                percentageSum += Number(priceRec.price)
                            }
                            // else{
                            //     totalGlobalPrice += Number(priceRec.price)/Number(product.shrimpQty)
                            // }
                        });
                        console.log(ocaenFreightPerKg,'hhhh')
                        console.log(totalGlobalPrice,'hhhmmm')
                        const freightAndForwardExp = Math.round(ocaenFreightPerKg+totalGlobalPrice)
                        //fixedCost
                        const fixedCost = Number(fixedRatesData[0].fixedCost)
                        const totalExpenses = Math.round(mfgCost+Number(saleCommission)+Number(packmaterailCost)+Number(freightAndForwardExp)+fixedCost)
                        //cost of production 
                        const productionCost = Number((((totalExpenses+rmCost)/(exchangeRate[0].exchangeRate))*0.454).toFixed(2))
                        console.log(productionCost,'productionCost')
                        
                        //COST OF SALES PER KG IN INR
                        const costOfSalesPerKgINR = rmCost+totalExpenses
                        //COST OF SALES PER KG IN USD
                        const costOfSalesPerKgUSD = Number((costOfSalesPerKgINR/exchangeRate[0].exchangeRate).toFixed(2))
                        //COST OF SALES PER LB IN USD
                        const costOfSaleUSBVal = Number(costOfSalesPerKgUSD*0.454)
                        let costOfSalesPerLBUSD = Number(costOfSaleUSBVal.toFixed(2))
                        let totCostOfSalesPerLBUSD = costOfSalesPerLBUSD
                        if(enquiryInfo[0].country == 'USA'){
                            percentageVal = costOfSaleUSBVal*Number((percentageSum/100))
                            totCostOfSalesPerLBUSD = Number(costOfSalesPerLBUSD)+Number(percentageVal)
                        }

                        //If Quotation Sent

                        let quotePrice = 0
                        let addedPriceToRmrate = 0
                        let reducedPriceToRmRate = 0
                        let saleCostToAddedRmrate = 0
                        let saleCostToReducedRmrate = 0
                        let incentives = 0
                        // if(quoteSentFlag){
                        //     quotePrice = qouteDetailsMap.get(product.variantId).quotePrice
                        //     addedPriceToRmrate = qouteDetailsMap.get(product.variantId).addedPriceToRmrate
                        //     reducedPriceToRmRate = qouteDetailsMap.get(product.variantId).reducedPriceToRmRate
                        //     saleCostToAddedRmrate = qouteDetailsMap.get(product.variantId).costOfSalesForAddedRmRate
                        //     saleCostToReducedRmrate = qouteDetailsMap.get(product.variantId).costOfSalesForReducedRmRate
                        //     // incentives = ((quotePrice-(oceanFreightInUsd/(product.quantity/0.454)))-(((quotePrice-(oceanFreightInUsd/(product.quantity/0.454))))*(1.35/100)))*(6.60/100)
                        //     incentives = qouteDetailsMap.get(product.variantId).incentives
                        // }
                        //if buyer offer price exists in the enquiry
                        let buyerOfferPrice = 0
                        let netProfitLoss = 0
                        let totalProfitLoss = 0
                        let plPercentage = 0
                        let contributionPercentage = 0
                        let prevConfirmedPrice = 0
                        //to calculate tot cost of sales based on buyer offer price if exists
                        const oceanFreightPrLb = (oceanFreightInUsd)/(product.shrimpQty/0.454)
                        console.log(buyerOfferPriceFlag,'buyerOfferPriceFlag')
                        if(product.buyerOfferPrice > 0 && !buyerOfferPriceFlag){
                            console.log('yesss')
                            buyerOfferPrice = product.buyerOfferPrice
                            percentageVal = Number(buyerOfferPrice-oceanFreightPrLb)*Number(percentageSum/100)
                            console.log(percentageVal,'percentageVal')
                            console.log(percentageSum,'percentageSum')
                            console.log(costOfSaleUSBVal,'costOfSaleUSBVal')
                            console.log(percentageVal)
                            totCostOfSalesPerLBUSD = Number((costOfSalesPerLBUSD+percentageVal).toFixed(2))
                            netProfitLoss = Number((Number(buyerOfferPrice)-Number(costOfSalesPerLBUSD)).toFixed(2))

                        }
                        if(buyerOfferPriceFlag){
                            console.log('nooo')
                            buyerOfferPrice = buyerPriceDataMap.get(product.variantId).buyerOfferPrice
                            netProfitLoss = (((buyerPriceDataMap.get(product.variantId)).netPLOnBuyerPrice))
                            totalProfitLoss = buyerPriceDataMap.get(product.variantId).totalProfitLoss
                            plPercentage = buyerPriceDataMap.get(product.variantId).plPercentage
                            contributionPercentage = buyerPriceDataMap.get(product.variantId).contributionPercentage
                            percentageVal = Number(buyerOfferPrice-oceanFreightPrLb)*Number(percentageSum/100)
                            totCostOfSalesPerLBUSD =Number((costOfSalesPerLBUSD+percentageVal).toFixed(2))
                        }
                        console.log(costOfSalesPerLBUSD,'costOfSalesPerLBUSDnnn')
                        //prevailing Market Rate
                        const prevailingMarketRate = ProductPriceInfoMap.get(product.variantId)!=undefined?ProductPriceInfoMap.get(product.variantId):0
                        //previous confirmed price 
                        if(sameBuyerEnquiryFlag){
                            if(sameBuyerEnquiriesMap.get(product.variantId)){
                                prevConfirmedPrice = Number(Number(sameBuyerEnquiriesMap.get(product.variantId)).toFixed(2))
                            }else{
                                if(prevenquiriesFlag){
                                    prevConfirmedPrice = prevEnquiryDataMap.get(product.variantId) ? Number(parseFloat(String(prevEnquiryDataMap.get(product.variantId))).toFixed(2)) : 0
                                }
                            }
                        }else{
                            if(prevenquiriesFlag){
                                prevConfirmedPrice =  prevEnquiryDataMap.get(product.variantId) ? Number(parseFloat(String(prevEnquiryDataMap.get(product.variantId))).toFixed(2)) : 0
                            }
                        }
                        const productName = product.variant +'/' + product.packStyle
                        const productObj = new productRates(product.variantId,product.shrimpQty,productName,product.leadType,yieldVal,packCount,rmCount,rmRate,rmCost,mfgCost,saleCommPer,saleCommission,packmaterailCost,freightAndForwardExp,totalExpenses,productionCost,fixedCost,costOfSalesPerKgINR,costOfSalesPerKgUSD,costOfSalesPerLBUSD,quotePrice,buyerOfferPrice,netProfitLoss,incentives,totalProfitLoss,plPercentage,contributionPercentage,prevConfirmedPrice,prevailingMarketRate,addedPriceToRmrate,reducedPriceToRmRate,saleCostToAddedRmrate,saleCostToReducedRmrate,product.styleWeighment,product.category,frozenyield,Number(percentageVal.toFixed(2)),totCostOfSalesPerLBUSD,product.group,product.cartons,product.containers,product.enquiryProductId)
                        productPricesData.push(productObj)
                    }
                    const resData = new CostSheetModel(enquiryInfo[0].buyer,enquiryInfo[0].agent,enquiryInfo[0].country,enquiryInfo[0].destination,enquiryInfo[0].shipTerms,oceanFreightInUsd,enquiryInfo[0].shipmentPeriod,enquiryInfo[0].noOfContainers,enquiryInfo[0].enquiryDate,datesInfo[0].assesmentApprovalDate,datesInfo[0].QuoteSentDate,datesInfo[0].Accepteddate,exchangeRate[0].exchangeRate,enquiryInfo[0].enquiryStatus,productPricesData,adPer,cvdPer)
                    //saving cost sheet data 
                    //mfg details 

                    const mfgData = await transmanager.getCustomRepository(CostSheetRepo).getFixedPriceInfo()
                    //to save freight charges,those should fetch from global prices 
                    const freightChargesData = await transmanager.getCustomRepository(CostSheetRepo).getGlobalPriceInfo()
                    const saveData = await this.saveCostSheetDetails(resData,req.enquiryid,mfgData,freightChargesData,ocaenFreightPerKg,transmanager)
                    if(saveData ==true){
                        await transmanager.completeTransaction()
                        return new CostingSheetResponse(true,1,'Cost Sheet data retreived',[resData])
                        // const getCostInfo = await this.getCostSheetInfo(new EnquiryIdreq(req.enquiryid))
                    }else{
                        await transmanager.releaseTransaction()
                        return new CostingSheetResponse(false,0,'Something went wrong in cost sheet generation')
                    }
                }else{
                     await transmanager.releaseTransaction()
                    return new CostingSheetResponse(false,0,'No exchange rate found for selected enquiry')
                }
        
            }else{
                await transmanager.releaseTransaction()
                return new CostingSheetResponse(false,0,'no enquiry found')
            }

        }else{
            const costsheetdata = await this.getCostSheetInfo(new EnquiryIdreq(req.enquiryid))
            if(costsheetdata.status){
                await transmanager.completeTransaction()
                return new CostingSheetResponse(true,100,'Already Cost Sheet Generated',costsheetdata.data)
            }else{
                await transmanager.releaseTransaction()
                return costsheetdata
            }

        }
        
    }

    async getCostSheetInfo(req:EnquiryIdreq):Promise<CostingSheetResponse>{
        const costSheetInfo = await this.costSheetRepo.getCostSheetInfo(req.enquiryid)
        const enquiryInfo = await this.enquiryRepo.getEnquiryDetailsForCostSheet(req.enquiryid)
        const datesInfo = await this.enquiryRepo.getEnquiryStatusInfo(req.enquiryid)
        const exchangeRate = await this.getExchangeRate(req.enquiryid,enquiryInfo[0].currencyId)
        const oceanFrieghtRate = await this.getOcenFrightOfEnquiry(enquiryInfo[0].countryId,enquiryInfo[0].destinationId)
        const oceanFreightInUsd = oceanFrieghtRate[0].oceanFreightRateUSD
        if(enquiryInfo.length > 0){
            const resData = new CostSheetModel(enquiryInfo[0].buyer,enquiryInfo[0].agent,enquiryInfo[0].country,enquiryInfo[0].destination,enquiryInfo[0].shipTerms,oceanFreightInUsd,enquiryInfo[0].shipmentPeriod,enquiryInfo[0].noOfContainers,enquiryInfo[0].enquiryDate,datesInfo[0].assesmentApprovalDate,datesInfo[0].QuoteSentDate,datesInfo[0].Accepteddate,exchangeRate[0].exchangeRate,enquiryInfo[0].enquiryStatus,costSheetInfo,costSheetInfo[0].ad,costSheetInfo[0].cvd)
            return new CostingSheetResponse(true,1,'Data Retrived',[resData])
        }else{
            return new CostingSheetResponse(false,0,'No data Found for selected Enquiry')
        }

    }
    async saveCostSheetDetails(req:CostSheetModel,enquiryId:number,mfgData:any,freightChargesData:any,oceanFreight:number,transmanager){
        // const transmanager = new GenericTransactionManager();

        // const manager = new Transtrab
        // await transmanager.startTransaction()
        let saveFlag = new Set<boolean>()
        for(const record of req.productRates){
        const costSheetObj = new CostSheetEntity()
            costSheetObj.addedRmRate = record.addedPriceToRmrate
            costSheetObj.buyerOfferPrice = record.buyerOfferPrice
            costSheetObj.contributionPercentage = record.contributionPercentage
            costSheetObj.costOfSalesInr = record.costOfSalesPerKgINR
            costSheetObj.costOfSalesUSDKG = record.costOfSalesPerKgUSD
            costSheetObj.costOfSalesUSDLB = record.costOfSalesPerLBUSD
            costSheetObj.enquiryEntity = new EnquiriesEntity()
            costSheetObj.enquiryEntity.enquiryId = enquiryId
            costSheetObj.enquiryProductEntity = new EnquiryProdctsEntity()
            costSheetObj.enquiryProductEntity.enquiryProductId = record.enquiryProductId
            costSheetObj.exchangeRate = req.exchangeRate
            costSheetObj.finalProfitLoss = record.totalProfitLoss
            costSheetObj.freightAndForwardExp = record.freightAndForwardExpenses
            costSheetObj.incentives = record.incentives
            costSheetObj.mfgCost = record.manufacturingCost
            costSheetObj.netPlOnBuyerPrice = record.netPLOnBuyerPrice
            costSheetObj.packCount = record.packCount
            costSheetObj.packMaterialCost = record.packingMaterial
            costSheetObj.plPercentage = record.plPercentage
            costSheetObj.prevConfirmedPrice = record.prevConfirmedPrice
            costSheetObj.quantity = record.quantity
            costSheetObj.quotePrice = record.quotePrice
            costSheetObj.quoteStatus = record.quotePrice >0 ? true : false
            costSheetObj.reducedRmRate = record.reducedPriceToRmRate
            costSheetObj.rmCost = record.rmCost
            costSheetObj.rmCount = record.rmCount
            costSheetObj.rmRate = record.prevailingRmRate
            costSheetObj.salesCommissionPercentage = record.salesCommissionpercentage
            costSheetObj.saleCommission = record.salesCommission
            costSheetObj.saleCostAddedRmrate = record.costOfSalesForAddedRmRate
            costSheetObj.saleCostReducedRmrate = record.costOfSalesForReducedRmRate
            costSheetObj.totalExpenses = record.totalExpenses
            costSheetObj.variantId = record.productId
            costSheetObj.yield = record.yieldPer
            costSheetObj.productionCost = record.costOfProduction
            costSheetObj.fixedCost = record.fixedCost
            costSheetObj.marketRate = record.prevailingMarketRate
            costSheetObj.adCvdPerValue = record.adCVDpercentageVal
            costSheetObj.totalSaleCost = record.totCostOfSalesPerLBUSD
            costSheetObj.adPercentage = req.ad
            costSheetObj.cvdPercentage = req.cvd
            const save = await transmanager.getCustomRepository(CostSheetRepo).save(costSheetObj)
            if(save){
                saveFlag.add(true)
                const mfgCostsheetObj = new MFGCostsEntity()
                mfgCostsheetObj.adminAndOtherCost = mfgData[0].procuremnetFreight
                mfgCostsheetObj.boilerFuelCost = mfgData[0].boilerFuelCost
                mfgCostsheetObj.consumableCost = mfgData[0].consumableCost
                mfgCostsheetObj.deheadingCost = mfgData[0].deheadingCost
                mfgCostsheetObj.depreciation = mfgData[0].depreciation
                mfgCostsheetObj.electricityCost = mfgData[0].electricityCost
                mfgCostsheetObj.enquiryEntity = new EnquiriesEntity()
                mfgCostsheetObj.enquiryEntity.enquiryId = enquiryId
                mfgCostsheetObj.financeCost = mfgData[0].financeCost
                mfgCostsheetObj.inhouseLabourCost = mfgData[0].inhouseLabourCost
                mfgCostsheetObj.otherDirectExpences = mfgData[0].otherDirectExpenses
                mfgCostsheetObj.procurementFrieght = mfgData[0].procuremnetFreight
                mfgCostsheetObj.peelingCost = 14//uncomm
                mfgCostsheetObj.qcCost = mfgData[0].qcCost
                mfgCostsheetObj.repairsAndMaintainance = mfgData[0].maintainanceCost
                mfgCostsheetObj.soakingCost = mfgData[0].soakingCost
                mfgCostsheetObj.salariesAndRemunarations = mfgData[0].salariesAndRemunarations
                mfgCostsheetObj.variantId = record.productId
                const mfgCostsSave = await transmanager.getRepository(MFGCostsEntity).save(mfgCostsheetObj)
                if(mfgCostsSave){
                    saveFlag.add(true)
                    //freight charges saving
                    const freightChagesObj = new FreightForwardExpensesEntity()
                    freightChagesObj.EIACharges = freightChargesData[0].eiaCharges
                    freightChagesObj.agriMarketingCess = freightChargesData[0].marketingCess
                    freightChagesObj.antiDumpingDuty = freightChargesData[0].antiDumpingDuty
                    freightChagesObj.clearingAndForwardingCharges = freightChargesData[0].forwardingCharges
                    freightChagesObj.enquiryEntity = new EnquiriesEntity()
                    freightChagesObj.enquiryEntity.enquiryId = enquiryId
                    freightChagesObj.localFreightCharges = freightChargesData[0].localFreight
                    freightChagesObj.marineInsurance = freightChargesData[0].marineInsurance
                    freightChagesObj.oceanFreight = oceanFreight
                    freightChagesObj.otherExpenses = freightChargesData[0].otherExp
                    freightChagesObj.surveyExpenses = freightChargesData[0].surveyExpenses
                    freightChagesObj.variantId = record.productId
                    const freightChargesSave = await transmanager.getRepository(FreightForwardExpensesEntity).save(freightChagesObj)
                    if(freightChargesSave){
                        saveFlag.add(true)
                    }else{
                        saveFlag.add(false)
                        break
                    }
                }else{
                    saveFlag.add(false)
                    break
                }
            }else{
                saveFlag.add(false)
                break
            }
        }
        if(!(saveFlag.has(false))){
            // await transmanager.completeTransaction()
            return true
        }else{
            await transmanager.releaseTransaction()
            return false
        }
    }
    async UpdateEnquiry(req:QuoteRequest):Promise<CommonResponse>{
        // try{
            // const exists = await this.costSheetRepo.find({enquiryEntity:{enquiryId:req.enquiryId}})
            // if(exists){
                const transmanager = new GenericTransactionManager();
            await transmanager.startTransaction()
            let saveFlag = new Set<boolean>()
                let recordsUpdated = false;
                let enquiryNo 
                for(const res of req.productPrices){
                    const validate = await transmanager.getRepository(CostSheetEntity).findOne({where:{variantId:res.productId, enquiryEntity:{enquiryId:req.enquiryId}},relations:['enquiryEntity']})
                    console.log(validate,'enquiryyyyyyyyyyyyyyyyyyyyyyyyy');
                    
                    if(validate){
                        const entity = new CostSheetEntity()
                        entity.finalProfitLoss = res.totalPL? res.totalPL:validate.finalProfitLoss
                        entity.plPercentage = res.plPercentage? res.plPercentage:validate.plPercentage
                        entity.contributionPercentage = res.contributionPercentage? res.contributionPercentage:validate.contributionPercentage

                        entity.quotePrice = res.quotePrice
                        entity.quoteStatus = true
                        entity.saleCostAddedRmrate = res.costOfSalesForAddedRmRate
                        entity.saleCostReducedRmrate = res.costOfSalesForReducedRmRate
                        entity.addedRmRate = req.addedPriceToRmrate
                        entity.reducedRmRate = req.reducedPriceToRmRate
                        entity.incentives = res.incentives
                        const updated = await transmanager.getRepository(CostSheetEntity).update({variantId:res.productId,enquiryEntity:{enquiryId:req.enquiryId}},entity)
                        // const updated = await this.costSheetRepo.update({variantId:res.productId,enquiryEntity:{enquiryId:req.enquiryId}},{quotePrice:res.quotePrice,quoteStatus:true,saleCostAddedRmrate:res.costOfSalesForAddedRmRate,incentives:res.incentives,saleCostReducedRmrate:res.costOfSalesForReducedRmRate,addedRmRate:req.addedPriceToRmrate,reducedRmRate:req.reducedPriceToRmRate})
                        console.log(updated,'updateddddddddddddddddd');
                    }
                        
                        recordsUpdated = true;
                        enquiryNo = validate.enquiryEntity.enquiryNumber
                        if(recordsUpdated){
                            saveFlag.add(true)
                        }else{
                            saveFlag.add(false)
                            break
                        }
                    }
                    if(recordsUpdated){
                        saveFlag.add(true)
                        const log = new EnquiryLogEntity()
                        log.enquiryEntity = new EnquiriesEntity()
                        log.enquiryEntity.enquiryId = req.enquiryId
                        log.enquiryNumber = enquiryNo
                        log.enquiryStatus = req.leadStatus
                        
                        await transmanager.getRepository(EnquiryLogEntity).save(log)
                        await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryId},{lifeCycleStatus:req.leadStatus})
                    }
                    if(!(saveFlag.has(false))){
                        await transmanager.completeTransaction()
            return new CommonResponse(true, 1,'Data Updated successfully')
                    }else{
                        await transmanager.releaseTransaction()
            return new CommonResponse(false, 0,'something went wrong')
    }
            // }
        //     return new CommonResponse(true, 1,'Data Updated successfully')

        // }catch(err){
        //     throw(err)
        // }
        
    }
    async UpdateBuyerWisePrices(req:QuoteRequest):Promise<CommonResponse>{
        // try{
            const transmanager = new GenericTransactionManager();
            await transmanager.startTransaction()
            let saveFlag = new Set<boolean>()
            // const exists = await this.costSheetRepo.find({enquiryEntity:{enquiryId:req.enquiryId}})
            // if(exists){
                let recordsUpdated = false;
                let enquiryNo 
                for(const res of req.productPrices){
                    const validate = await transmanager.getRepository(CostSheetEntity).findOne({where:{variantId:res.productId, enquiryEntity:{enquiryId:req.enquiryId}},relations:['enquiryEntity']})
                    
                    if(validate){
                        saveFlag.add(true)
                        const entity = new CostSheetEntity()
                        entity.netPlOnBuyerPrice = res.netPLOnBuyerPrice
                        entity.contributionPercentage = res.contributionPercentage
                        entity.buyerOfferPrice = res.buyerPrice
                        entity.finalProfitLoss = res.totalPL
                        entity.plPercentage = res.plPercentage
                        const updated = await transmanager.getRepository(CostSheetEntity).update({variantId:res.productId,enquiryEntity:{enquiryId:req.enquiryId}},{netPlOnBuyerPrice:res.netPLOnBuyerPrice,buyerOfferPrice:res.buyerPrice,plPercentage:res.plPercentage,finalProfitLoss:res.totalPL,contributionPercentage:res.contributionPercentage})
                        }
                        recordsUpdated = true;
                        enquiryNo = validate.enquiryEntity.enquiryNumber
                        if(recordsUpdated){
                            saveFlag.add(true)
                        }else{
                            saveFlag.add(false)
                            break
                        }
                    }
                    
                    if(recordsUpdated){
                        saveFlag.add(true)
                        const log = new EnquiryLogEntity()
                        log.enquiryEntity = new EnquiriesEntity()
                        log.enquiryEntity.enquiryId = req.enquiryId
                        log.enquiryNumber = enquiryNo
                        log.enquiryStatus = req.leadStatus
                        
                        await transmanager.getRepository(EnquiryLogEntity).save(log)
                        console.log(await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryId},{lifeCycleStatus:req.leadStatus}),'888888888888');
                        
                        const enquiryUpdate = await transmanager.getRepository(EnquiriesEntity).update({enquiryId:req.enquiryId},{lifeCycleStatus:req.leadStatus})
                        console.log(enquiryUpdate,'9999999999999999999');
                        
                    }
                    if(!(saveFlag.has(false))){
                        await transmanager.completeTransaction()
            return new CommonResponse(true, 1,'Data Updated successfully')
                    }else{
                        await transmanager.releaseTransaction()
            return new CommonResponse(false, 0,'something went wrong')
    }
            // }
        //     return new CommonResponse(true, 1,'Data Updated successfully')

        // }catch(err){
        //     throw(err)
        // }
        
    }
    async UpdateCostingApproval(req:EnquiryAssessmentUpdateReq):Promise<CommonResponse>{
        try{
              const enquiry = await this.enquiriesRepo.findOne({enquiryId:req.id})
              
              if(enquiry){
                let update
                if(req.status === EnquiryLifecycleStatusEnum.REJECTED){
                update = await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,enquiryRejectReason:req.rejectReason,createdUser:req.createdUser})
                }

                if(req.status === EnquiryLifecycleStatusEnum.ACCEPTED){
                  update=  await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,freezeStatus:true,createdUser:req.createdUser})
                }
                if(req.status != undefined){
                    update=  await this.enquiriesRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,createdUser:req.createdUser})
                  }
                if(update.affected){
                    const log = new EnquiryLogEntity()
                        log.enquiryEntity = new EnquiriesEntity()
                        log.enquiryEntity.enquiryId = req.id
                        log.enquiryNumber = enquiry.enquiryNumber
                        log.enquiryStatus = req.status
                        
                        await this.enquiryLogRepo.save(log)
                }
              }
            return new CommonResponse(true, 1,'Data Updated successfully')

        }catch(err){
            throw(err)
        }
        
    }

    async getEnquiryDestinations (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.destination_id AS destinationId,d.destination_name AS destination
            FROM ${appSettings.enquiry_db}.enquiries e
            LEFT JOIN ${appSettings.masters_db}.destination d ON d.destination_id = e.destination_id
            WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and e.life_cycle_status ='${req.tabName}' and d.destination_name is not null`
            }
            query = query + ` GROUP BY d.destination_name ORDER BY d.destination_name`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getEnquiryUnits (req:getAllEnquiryInfoReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT e.unit_id,u.unit_name AS unitName
            FROM ${appSettings.enquiry_db}.enquiries e
            LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = e.unit_id
            WHERE 1=1`
            if(req.tabName != undefined){
                query=query+` and e.life_cycle_status ='${req.tabName}' and u.unit_name is not null`
            }
            query = query + ` GROUP BY u.unit_name ORDER BY u.unit_name`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async updateConfirmedContainers(req:ContainersReq):Promise<CommonResponse>{
        const manager = new GenericTransactionManager()
        try{
            await manager.startTransaction()
            let saveFlag = new Set<boolean>()
            for(const rec of req.confirmedContainersInfo){
                const updateContainers = await manager.getRepository(EnquiryProdctsEntity).update({enquiryProductId:rec.enquiryProductId},{confirmedContainers:rec.confirmedContainers})
                if(!(updateContainers.affected)){
                    saveFlag.add(false)
                    await manager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in confirmed containers updation')
                }
            }
            if(!(saveFlag.has(false))){
                const enqReq = new EnquiryAssessmentUpdateReq(req.enquiryId,EnquiryLifecycleStatusEnum.ACCEPTED,null,req.createdUser)
                const updateEnquiryStatus = await this.UpdateCostingApproval(enqReq)
                if(updateEnquiryStatus.status){
                    await manager.completeTransaction()
                    return new CommonResponse(true,1,'Approved Successfully')
                }else{
                    await manager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in enquiry status updation')
                }
            }
        }catch(err){
            console.log(err,'====')
            await manager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong')

        }
    }
}